module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"followUp":"Add comments or questions"},"fr":{"followUp":"Ajouter des commentaires ou des questions"},"es":{"followUp":"Agregar comentarios o preguntas"},"pt":{"followUp":"Adicione comentários ou perguntas"},"ar":{"followUp":"أضف تعليقات أو أسئلة"},"sv":{"followUp":"Lägg till kommentarer eller frågor"},"fi":{"followUp":"Lisää kommentteja tai kysymyksiä"}}')
  delete Component.options._Ctor
}
